import { ChangeDetectionStrategy, Component, DestroyRef, Input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ExportOptions } from '@hq-core/internal-export/internal-export.model';
import { InternalExportService } from '@hq-core/internal-export/internal-export.service';
import { LaunchDarklyFeatureFlag } from '@hq-core/models/feature-flag';
import { FeatureFlagService } from '@cia-front-end-apps/shared/feature-flag/feature-flag.service';
import { Observable } from 'rxjs';

@Component({
    selector: 'hq-internal-export-button',
    template: `
        <button mat-flat-button
                color="accent"
                (click)="onExport()"
                *ngIf="hasExportEnabled$ | async">
            <mat-icon>file_download</mat-icon>
            EXPORT
        </button>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class InternalExportButtonComponent implements OnInit {
    @Input() exportOptions: ExportOptions;

    hasExportEnabled$: Observable<boolean>;

    constructor(
        private featureFlagService: FeatureFlagService,
        private internalExportService: InternalExportService,
        private destroyRef: DestroyRef,
    ) {
    }

    ngOnInit(): void {
        this.hasExportEnabled$ = this.featureFlagService.getFlag(LaunchDarklyFeatureFlag.EnableInternalExports);
    }

    onExport(): void {
        this.internalExportService.openExportDialog(this.exportOptions).pipe(
            takeUntilDestroyed(this.destroyRef)
        ).subscribe();
    }
}
